import { lazy, Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import BackToTop from "./components/BackToTop";
import Header from "./components/Header";
import Menu from "./components/Menu";
import RequireAuth from "./router/RequireAuth";
const Advertisement = lazy(() => import("./pages/Advertisement"));
const AdvertisementEdit = lazy(() => import("./pages/AdvertisementEdit"));
const ApprovedReview = lazy(() => import("./pages/ApprovedReview"));
const Articles = lazy(() => import("./pages/Articles"));
const ArticleCreate = lazy(() => import("./pages/ArticlesCreate"));
const ArticlesEdit = lazy(() => import("./pages/ArticlesEdit"));
const Banner = lazy(() => import("./pages/Banner"));
const BannerEdit = lazy(() => import("./pages/BannerEdit"));
const Categories = lazy(() => import("./pages/Categories"));
const CategoriesEdit = lazy(() => import("./pages/CategoriesEdit"));
const CategoriesCreate = lazy(() => import("./pages/CategoritesCreate"));
const Comment2s = lazy(() => import("./pages/Comment2s"));
const Comment2sCreate = lazy(() => import("./pages/Comment2sCreate"));
const Comment2sEdit = lazy(() => import("./pages/Comment2sEdit"));
const Comment2sIndex = lazy(() => import("./pages/Comment2sIndex"));
const CommentEdit = lazy(() => import("./pages/CommentEdit"));
const Comments = lazy(() => import("./pages/Comments"));
const Contact = lazy(() => import("./pages/Contact"));
const ContactDetail = lazy(() => import("./pages/ContactDetail"));
const ContentOverview = lazy(() => import("./pages/ContentOverview"));
const Contents = lazy(() => import("./pages/Contents"));
const ContentsCreate = lazy(() => import("./pages/ContentsCreate"));
const Faqs = lazy(() => import("./pages/Faqs"));
const FaqsCreate = lazy(() => import("./pages/FaqsCreate"));
const FaqsDetail = lazy(() => import("./pages/FaqsDetail"));
const FaqsEdit = lazy(() => import("./pages/FaqsEdit"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Function = lazy(() => import("./pages/Function"));
const FunctionInsert = lazy(() => import("./pages/FunctionInsert"));
const FunctionUpdate = lazy(() => import("./pages/FunctionUpdate"));
const Group = lazy(() => import("./pages/Group"));
const GroupInsert = lazy(() => import("./pages/GroupInsert"));
const Groups = lazy(() => import("./pages/Groups"));
const GroupsCreate = lazy(() => import("./pages/GroupsCreate"));
const GroupsEdit = lazy(() => import("./pages/GroupsEdit"));
const GroupUpdate = lazy(() => import("./pages/GroupUpdate"));
const LegalServices = lazy(() => import("./pages/LegalServices"));
const LegalServicesAdvice = lazy(() => import("./pages/LegalServicesAdvice"));
const LegalServicesCreate = lazy(() => import("./pages/LegalServicesCreate"));
const LegalServicesEdit = lazy(() => import("./pages/LegalServicesEdit"));
const ListPackage = lazy(() => import("./pages/ListPackage"));
const ListPackageCreate = lazy(() => import("./pages/ListPackageCreate"));
const ListPackageEdit = lazy(() => import("./pages/ListPackageEdit"));
const Login = lazy(() => import("./pages/Login"));
const Mails = lazy(() => import("./pages/Mails"));
const MailsCreate = lazy(() => import("./pages/MailsCreate"));
const MailsEdit = lazy(() => import("./pages/MailsEdit"));
const Orders = lazy(() => import("./pages/Orders"));
const Pages = lazy(() => import("./pages/Pages"));
const PagesCreate = lazy(() => import("./pages/PagesCreate"));
const PagesEdit = lazy(() => import("./pages/PagesEdit"));
const PendingReview = lazy(() => import("./pages/PendingReview"));
const ReviewCreate = lazy(() => import("./pages/ReviewCreate"));
const ReviewEdit = lazy(() => import("./pages/ReviewEdit"));
const Seo = lazy(() => import("./pages/Seo"));
const SeoCreate = lazy(() => import("./pages/SeoCreate"));
const SeoEdit = lazy(() => import("./pages/SeoEdit"));
const ServicePackage = lazy(() => import("./pages/ServicePackage"));
const ServicePackageCreate = lazy(() => import("./pages/ServicePackageCreate"));
const ServicePackageEdit = lazy(() => import("./pages/ServicePackageEdit"));
const ServiceRegional = lazy(() => import("./pages/ServicesRegional"));
const SevicesRegionalEdit = lazy(() => import("./pages/ServicesRegionalEdit"));
const Setting = lazy(() => import("./pages/Setting"));
const SevicesRegionalCreate = lazy(() => import("./pages/SevicesRegionalCreate"));
const Users = lazy(() => import("./pages/Users"));
const UsersCreate = lazy(() => import("./pages/UsersCreate"));
const UsersEdit = lazy(() => import("./pages/UsersEdit"));
function App() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 992) {
        setCollapsed(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const location = useLocation();
  const hideLayout = location.pathname.startsWith("/acp/Account");
  return (
    <>
      {!hideLayout && (
        <Header
          onToggleMenuMobile={() => setMobileOpen((m) => !m)}
          onToggleMenuDesktop={() => setCollapsed((c) => !c)}
          collapsed={collapsed}
        />
      )}
      <div className={`app-shell ${hideLayout ? "no-flex" : ""}`}>
        {!hideLayout && <Menu collapsed={collapsed} mobileOpen={mobileOpen} />}
        <main className={`app-content ${mobileOpen ? "no-margin" : ""}`}>
          <Suspense fallback={<div className="page-loading">Đang tải...</div>}>
            <Routes>
            <Route path="/" element={<RequireAuth root />} />
            <Route path="/acp/Account/Login" element={<Login />} />
            <Route
              path="/acp/Account/ForgotPassword"
              element={<ForgotPassword />}
            />
            <Route path="/acp" element={<RequireAuth />}>
              <Route index element={<Navigate to="Articles" replace />} />
              <Route path="Articles" element={<Articles />} />
              <Route path="Articles/Create" element={<ArticleCreate />} />
              <Route path="Banners" element={<Contents />} />
              <Route path="Banners/Create" element={<ContentsCreate />} />
              <Route path="Comments" element={<Comments />} />
              <Route path="Comment2s" element={<Comment2s />} />
              <Route path="Comment2s/Index1" element={<Comment2sIndex />} />
              <Route path="Comment2s/Create" element={<Comment2sCreate />} />
              <Route path="comment2s/edit" element={<Comment2sEdit />} />
              <Route path="Contacts" element={<Contact />} />
              <Route path="contacts/detail/:id" element={<ContactDetail />} />
              <Route path="FAQs" element={<Faqs />} />
              <Route path="FAQs/Create" element={<FaqsCreate />} />
              <Route path="FAQs/Detail/:id" element={<FaqsDetail />} />
              <Route path="faqs/edit" element={<FaqsEdit />} />
              <Route path="Mails" element={<Mails />} />
              <Route path="Mails/Create" element={<MailsCreate />} />
              <Route path="mails/edit" element={<MailsEdit />} />
              <Route path="Orders" element={<Orders />} />
              <Route path="Pages" element={<Pages />} />
              <Route path="Pages/Create" element={<PagesCreate />} />
              <Route path="pages/edit" element={<PagesEdit />} />
              <Route path="Settings/Edit" element={<Setting />} />
              <Route path="Group" element={<Group />} />
              <Route path="Group/UpdateGroup" element={<GroupUpdate />} />
              <Route path="Group/InsertGroup" element={<GroupInsert />} />
              <Route path="Page" element={<Function />} />
              <Route path="Page/UpdatePage" element={<FunctionUpdate />} />
              <Route path="Page/InsertPage" element={<FunctionInsert />} />
              <Route path="Banner_user_image" element={<Banner />} />

              <Route path="Banner_user_image/Edit" element={<BannerEdit />} />
              <Route path="Users" element={<Users />} />
              <Route path="users/edit/:id" element={<UsersEdit />} />
              <Route path="Users/Create" element={<UsersCreate />} />
              <Route path="Groups" element={<Groups />} />
              <Route path="groups/edit" element={<GroupsEdit />} />
              <Route path="Groups/Create" element={<GroupsCreate />} />
              <Route path="UserBanner" element={<Advertisement />} />
              <Route path="userbanner/edit" element={<AdvertisementEdit />} />
              <Route path="Categories" element={<Categories />} />
              <Route path="Categories/Edit" element={<CategoriesEdit />} />
              <Route path="Categories/Create" element={<CategoriesCreate />} />
              <Route path="DichVuPhapLy" element={<LegalServices />} />
              <Route
                path="DichVuPhapLy/Create"
                element={<LegalServicesCreate />}
              />
              <Route
                path="DichVuPhapLy/edit/:id"
                element={<LegalServicesEdit />}
              />
              <Route
                path="DichVuPhapLy_TuVan"
                element={<LegalServicesAdvice />}
              />
              <Route path="GoiDichVu" element={<ServicePackage />} />
              <Route
                path="GoiDichVu/Create"
                element={<ServicePackageCreate />}
              />
              <Route
                path="GoiDichVu/Edit/:id"
                element={<ServicePackageEdit />}
              />
              <Route path="GoiDichVu_khuvuc" element={<ServiceRegional />} />

              <Route
                path="GoiDichVu_khuvuc/Edit/"
                element={<SevicesRegionalEdit />}
              />
              <Route
                path="GoiDichVu_khuvuc/Create"
                element={<SevicesRegionalCreate />}
              />
              <Route path="GoiDichVu_datgoi" element={<ListPackage />} />
              <Route
                path="GoiDichVu_datgoi/Edit/"
                element={<ListPackageEdit />}
              />
              <Route
                path="GoiDichVu_datgoi/Create"
                element={<ListPackageCreate />}
              />
              <Route path="GoiDichVu_DanhGia" element={<PendingReview />} />
              <Route
                path="GoiDichVu_DanhGia/Index_DaDuyet"
                element={<ApprovedReview />}
              />
              <Route
                path="GoiDichVu_DanhGia/Create"
                element={<ReviewCreate />}
              />
              <Route path="GoiDichVu_DanhGia/edit" element={<ReviewEdit />} />
              <Route path="Lawyer_SEO" element={<Seo />} />
              <Route path="Lawyer_SEO/Edit" element={<SeoEdit />} />
              <Route path="Lawyer_SEO/Create" element={<SeoCreate />} />
              <Route path="Articles/edit" element={<ArticlesEdit />} />
              <Route path="Comments/Edit" element={<CommentEdit />} />

              <Route path="Dashboard/Content" element={<ContentOverview />} />
            </Route>
            </Routes>
          </Suspense>
        </main>
      </div>
      <BackToTop />
    </>
  );
}

export default App;
